import Toastify from 'toastify-js'

const state = () => {
  return {
    type: null,
    message: null,
    toastType: null,
    toastMessage: null,
    toastDescription: null,

    toastSuccess: false,
    toastSuccessMsg: null,
    toastSuccessDesc: null,
    toastError: false,
    toastErrorMsg: null,
    toastErrorDesc: null
  }
}

const actions = {
  success({ commit }, message) {
    commit('success', message)
  },
  error({ commit }, message) {
    commit('error', message)
  },
  clear({ commit }) {
    commit('clear')
  }
}

const mutations = {
  success(state, message) {
    state.type = 'success'
    state.message = message
  },
  error(state, message) {
    state.type = 'danger'
    state.message = message
  },
  clear(state) {
    state.type = null
    state.message = null
  },
  toast(state, data) {
    state.toastType = data.type || 'danger'
    state.toastMessage = data.message
    state.toastDescription = data.description
  },
  toastSuccess(state, data) {
    state.toastSuccess = true
    state.toastSuccessMsg = data.message
    state.toastSuccessDesc = data.description
  },
  toastError(state, data) {
    state.toastError = true
    state.toastErrorMsg = data.message
    state.toastErrorDesc = data.description
  },
  toastSuccessShow() {
    Toastify({
      node: cash('#success-notification-content')
        .clone()
        .removeClass('hidden')[0],
      duration: 1500,
      newWindow: true,
      close: true,
      gravity: 'top',
      position: 'right',
      stopOnFocus: true
    }).showToast()
  },
  toastErrorShow() {
    Toastify({
      node: cash('#error-notification-content')
        .clone()
        .removeClass('hidden')[0],
      duration: 5000,
      newWindow: true,
      close: true,
      gravity: 'top',
      position: 'right',
      stopOnFocus: true
    }).showToast()
  },
  toastShow() {
    Toastify({
      node: cash('#success-notification-content')
        .clone()
        .removeClass('hidden')[0],
      duration: 1500,
      newWindow: true,
      close: true,
      gravity: 'top',
      position: 'right',
      stopOnFocus: true
    }).showToast()
  },

  // toastDanger(state, data) {
  //   state.toastType = 'danger'
  //   state.toastMessage = data.message
  //   state.toastDescription = data.description
  //   // if (state.toastMessage !== null) {
  //   console.log(state)
  //   // setTimeout(() => {
  //   Toastify({
  //     node: cash('#success-notification-content')
  //       .clone()
  //       .removeClass('hidden')[0],
  //     duration: 3000,
  //     newWindow: true,
  //     close: true,
  //     gravity: 'top',
  //     position: 'right',
  //     stopOnFocus: true
  //   }).showToast()
  //   // }, 100)

  //   // }
  // }
  async toastDanger(state, data) {
    const res = await Promise.all([
      (state.toastType = 'danger'),
      (state.toastMessage = data.message),
      (state.toastDescription = data.description)
    ])
    // console.log(res[0])

    // if (state.toastMessage !== null) {
    // console.log({ res }, res.includes(null))
    if (!res.includes(null)) {
      Toastify({
        node: cash('#success-notification-content')
          .clone()
          .removeClass('hidden')[0],
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: 'top',
        position: 'right',
        stopOnFocus: true
      }).showToast()
    }
    // setTimeout(() => {
    // }, 100)

    // }
  }
}

const getters = {
  getMyState: state => state.type
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
